export const CURTAIN_OPEN = 'CURTAIN_OPEN';
export const CURTAIN_CLOSE = 'CURTAIN_CLOSE';
